import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

export interface SplitPaneLayoutProps {
  /** Left pane (queue table). Always rendered. */
  left: ReactNode;
  /** Primary right pane (detail panel). Hidden below `laptop`. */
  right?: ReactNode;
  /** Deprecated: the AP invoice flow now exposes source files as detail links. */
  rightSecondary?: ReactNode;
  className?: string;
}

/**
 * Two-pane layout for queue + detail surfaces.
 *
 * Behavior by breakpoint:
 * - `< laptop` (1024px): only `left` renders, full-width. The page is
 *   responsible for opening `DetailDrawer` on row clicks at this size.
 * - `≥ laptop`: `left` 45% / `right` 55% horizontal split.
 *
 * v1.1 keeps the proportions fixed; a draggable splitter is deferred to v1.2.
 */
export function SplitPaneLayout({
  left,
  right,
  className,
}: SplitPaneLayoutProps) {
  return (
    <div className={cn('flex w-full flex-col gap-12 laptop:flex-row laptop:gap-16', className)}>
      <div className="min-w-0 flex-1 laptop:basis-[45%]">{left}</div>
      {right !== undefined && (
        <div className="hidden min-w-0 laptop:block laptop:basis-[55%]">{right}</div>
      )}
    </div>
  );
}
